import { useMutation } from '@hooks/reactQuery';

import { updateMiddlewareLogPM } from '@api/middlewareSMO';

import { IMiddlewareUpdateLogPMDTO } from '@interfaces/middlewareSMO/dto/middlewareSMO';

import { MIDDLEWARE_LOG_PM_UPDATE } from '@constants/queryKeys';

import useInvalidateMiddlewareSMO from './useInvalidateMiddlewareSMO';

interface IUseMutateMiddlewareUpdateLogPMReturned {
	updateMiddlewareLogPM: (dto: IMiddlewareUpdateLogPMDTO) => void;
	isLoadingUpdateMiddlewareLogPM: boolean;
}

const useMutateMiddlewareUpdateLogPM = (handleCloseModal: () => void): IUseMutateMiddlewareUpdateLogPMReturned => {
	const invalidateMiddlewareSMO = useInvalidateMiddlewareSMO();

	const {
		isLoading,
		mutate,
	} = useMutation<IMiddlewareUpdateLogPMDTO>({
		mutationKey: [MIDDLEWARE_LOG_PM_UPDATE],
		mutationFn: updateMiddlewareLogPM,
		onSuccess: () => {
			handleCloseModal();

			return invalidateMiddlewareSMO();
		},
	});

	return {
		updateMiddlewareLogPM: mutate,
		isLoadingUpdateMiddlewareLogPM: isLoading,
	};
};

export default useMutateMiddlewareUpdateLogPM;
